import {
    RE_LIST,
    RE_STORE_ALL,
    RE_STORE_HOUSE,
    RE_REMOVE_HOUSE,
    RE_STORE_PARTNER,
    RE_REMOVE_PARTNER,
    RE_SAVE_HOUSE,
    RE_DELETE_HOUSE,
    RE_SAVE_PARTNER,
    RE_ADD_PARTNER,
    RE_DELETE_PARTNER,
    RE_SAVE_EXPENSE,
    RE_DELETE_EXPENSE,
} from '../../constants/realEstate';

export const listRealEstate = (data) => ({ type: RE_LIST, data });

export const storeRealEstate = (payload) => ({ type: RE_STORE_ALL, payload });

export const storeHouse = (house) => ({ type: RE_STORE_HOUSE, house });
export const removeHouse = (houseId) => ({ type: RE_REMOVE_HOUSE, houseId });

export const storePartner = (partner) => ({ type: RE_STORE_PARTNER, partner });
export const removePartner = (personId) => ({ type: RE_REMOVE_PARTNER, personId });

export const saveHouse = (data, callback) => ({ type: RE_SAVE_HOUSE, data, callback });
export const deleteHouse = (data, callback) => ({ type: RE_DELETE_HOUSE, data, callback });
export const savePartner = (data, callback) => ({ type: RE_SAVE_PARTNER, data, callback });
export const addPartnerUser = (data, callback) => ({ type: RE_ADD_PARTNER, data, callback });
export const deletePartner = (data, callback) => ({ type: RE_DELETE_PARTNER, data, callback });
export const saveExpense = (data, callback) => ({ type: RE_SAVE_EXPENSE, data, callback });
export const deleteExpense = (data, callback) => ({ type: RE_DELETE_EXPENSE, data, callback });
